<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

import {getIsTokenOverdue, setToken, setTokenOverdueTime} from "@/utils/storage";
import {getNewVersionToken} from "@/api/ZlInterface";

export default {
  name: 'App',
  mounted() {
    let isTokenOverdue = getIsTokenOverdue()
    if (isTokenOverdue) {
      getNewVersionToken().then(res => {
        if (res.code === 200) {
          setToken(res.data.token)
          setTokenOverdueTime(res.data.expTime)
        }
      })
    }
    this.resize();
  },
  methods: {
    resize() {
      $(window).resize(() => {
        let w = $(window).width();
        $('html').css({fontSize: w / 375 * 100 + 'px'});
        $('body').css({fontSize: '0.14rem'});
      });
      $(window).resize();
    },
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  background-color: #F4F6FA;
}
</style>



// WEBPACK FOOTER //
// src/App.vue